import { useState } from "react";
import { RaportSection } from "../../../types/Rows";
import { ReportSection } from "./QuestionList";

export const SectionsList = ({
  templateId,
  sections,
  reportId,
  isCentralMonitoring = false,
}: {
  templateId: string;
  sections: RaportSection[];
  reportId: string;
  isCentralMonitoring?: boolean;
}) => {
  const sorted = [...sections].sort((a, b) => (a.weight < b.weight ? -1 : 1));
  const [expandAll, setExpandAll] = useState<boolean | null>(null);

  // For CM: compute flat question offset per section so numbering is 1,2,3... across all sections
  let flatOffset = 0;

  return (
    <div>
      {!isCentralMonitoring && sorted.length > 1 && (
        <div className="flex justify-end mb-2">
          <button
            onClick={() => setExpandAll((v) => (v === true ? false : true))}
            className="text-[12px] text-[var(--sc-muted)] hover:text-[var(--sc-text)] transition-colors bg-transparent border-none cursor-pointer p-0"
          >
            {expandAll === true ? "Zwiń wszystkie" : "Rozwiń wszystkie"}
          </button>
        </div>
      )}
      {sorted.map((section, index) => {
        const sectionOffset = flatOffset;
        if (isCentralMonitoring) {
          const rootCount = section.questionsWithAnswer.filter(
            (q) => !q.parentId
          ).length;
          flatOffset += rootCount;
        }
        return (
          <ReportSection
            key={section.id}
            index={index + 1}
            section={section}
            items={section.questionsWithAnswer}
            templateId={templateId}
            reportId={reportId}
            isCentralMonitoring={isCentralMonitoring}
            flatOffset={sectionOffset}
            forceOpen={expandAll}
          />
        );
      })}
    </div>
  );
};
